const width = "60.7%"
const height = "6.4%"
const left = "18.7%"
const isExternal = true
const iniTop = 12.4
const padding = 19.8 - iniTop

const links = [
    ["Supplier Security WebApp", "https://www.isflive.org/s/topic/0TO0J0000009AOCWA2/supply-chain"],
    ["ICS Insights series", "https://www.isflive.org/s/topic/0TO0J0000009AOWWA2/ics-security-support-community"],
    ["Threat Intelligence: React and prepare", "https://www.isflive.org/s/article/Threat-Intelligence-react-and-prepare"],
    ["ISF Aligned Tools Suite 2022", "https://www.isflive.org/s/isf-aligned-tools-suite"],
    ["Embedding Security into Agile Development: Ten principles for rapid improvement", "https://www.isflive.org/s/article/Embedding-Security-into-Agile-Development-Ten-principles-for-rapid-improvement-Report"],
    ["Standard of Good Practice for Information Security", "https://www.isflive.org/s/article/Standard-of-Good-Practice-for-Information-Security-2022-All-Files?topicId=0TO0J0000009AOIWA2"],
    ["Managing Cyber Threats During Periods of Instability", "https://www.isflive.org/s/cyber-resilience"],
    ["Threat Horizon 2022: The disintegration of trust", "https://www.isflive.org/s/article/Threat-Horizon-2024-the-disintegration-of-trust-report?topicId=0TO0J0000009AODWA2"],
    ["QIRA Assistant", "https://www.isflive.org/s/article/Quantitative-Information-Risk-Assessment-QIRA-Methodology-Assistant"],
    ["Information Security in Mergers & Acquisitions", "https://www.isflive.org/s/article/Information-Security-in-Mergers-and-Acquisitions?topicId=0TO6M0000005B8PWAU"]
].map(line => ({
    label: line[0],
    href: line[1]
}))

export default [...links.map((cur, idx) => {
    return {width, height, left, isExternal, top: `${iniTop + (padding * idx)}%`, ...cur, target: "_blank"}
}),
    {
        width: "28.7%",
        height: "5.4%",
        left: "34.7%",
        isExternal,
        top: "88%",
        target: "_blank",
        label: "For more, please visit the ISF Library",
        href: "https://www.isflive.org/s/knowledge-library"
    }
]